import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import WHtmlToolTip from "@/components/tooltip/w-html-tooltip.vue";
let AiCreditsToolTip = class AiCreditsToolTip extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "placement", void 0);
  }
};
__decorate([Prop({
  default: 'top-start'
})], AiCreditsToolTip.prototype, "placement", void 0);
AiCreditsToolTip = __decorate([Component({
  components: {
    WHtmlToolTip
  }
})], AiCreditsToolTip);
export default AiCreditsToolTip;